<template>
  <div>
    <div v-if="editGroup">
      <table class="table table-sm table-hover mt-1">
        <thead>
        <tr>
          <th>Группа</th>
          <th>проекты</th>
          <th>смена 1</th>
          <th>смена 2</th>
          <th>график</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="r in editGroup.data" v-if="!r.to_delete">
          <td>
            <multiselect v-model="r.group" :disabled="!!editGroup.id" placeholder="Выберите группу" label="id"
                         track-by="id"
                         :options="allGroups"
                         :option-height="104" :show-labels="false">
              <template #singleLabel="props">
              <span class="option__desc">
                <span class="option__title">{{ props.option.title }} ({{ props.option.id }})</span>
              </span>
              </template>
              <template #option="props">
                <!--              <img class="option__image" :src="props.option?.img" alt="No Man’s Sky"/>-->
                <div class="option__desc">
                  <span class="option__title">{{ props.option.title }}</span>
                </div>
                <div class="mt-1">
                  <template v-if="props.option.data?.projects">
                    <div class="text-muted">
                    <span v-for="(p,i) in props.option.data.projects">
                      {{ i !== 0 ? ', ' : '' }}{{ $AllProjects[p]?.title }}
                    </span>
                    </div>
                  </template>
                  <template v-else>
                    <span class="text-muted">Все проекты</span>
                  </template>
                </div>
              </template>
            </multiselect>
          </td>
          <td>
            <template v-if="r?.group?.data?.projects">
              <div class="flex flex_gap_10 flex-wrap">
              <span class="badge badge-info" v-for="p in r.group.data.projects">
                {{ $AllProjects[p]?.title }}
              </span>
              </div>
            </template>
            <template v-else>
              Все проекты
            </template>
          </td>
          <template v-for="i in [1,2]">
            <td>
              <template v-if="allUsers">
                <multiselect
                  v-model="r.users[`shift_${i}`]"
                  :options="allUsers"
                  :multiple="true"
                  :disabled="!!editGroup.id"
                  label="name"
                  track-by="name"
                  placeholder="Выберите пользователя"
                  select-label="Выбрать"
                  deselect-label="Убрать пользователя">
                  <template #singleLabel="props">
                    {{ props.option.name }}
                    ({{
                      props.option?.role ? props.option.role : props.option.roles.find((r) => r.name === 'manager') ? 'М' : 'П'
                    }})
                  </template>
                  <template #option="props">
                    {{ props.option.name }}
                    ({{
                      props.option?.role ? props.option.role : props.option.roles.find((r) => r.name === 'manager') ? 'М' : 'П'
                    }})
                  </template>
                </multiselect>
              </template>
              <template v-else>
                <div>
                  <p v-for="u in r.users[`shift_${i}`]">
                    ({{ u.id }}) {{ u.name }} ({{ u.role === 'manager' ? 'менеджер' : 'помощник' }})
                  </p>
                </div>
              </template>
            </td>
          </template>
          <td>
            <select v-model="r.schedule" :disabled="!!editGroup.id" class="form-control">
              <option value="0" disabled>Выберите график</option>
              <option v-for="s in schedule" :value="s.id">{{ s.start }} - {{ s.end }} {{ s.title }}</option>
            </select>
          </td>
          <td>
            <button v-if="!editGroup.id" @click="r.to_delete = true" class="btn btn-outline-danger"><i
              class="icon-fa icon-fa-remove"/>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="text-right" v-if="!editGroup.id">
        <LoadingButton
          title='Сохранить'
          type="button"
          :loading="loading"
          :onClick="() => saveGroup()"
          :color="$constants.SUCCESS_COLOR"
          className="btn btn-outline-success"
        />
      </div>
    </div>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect'
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import UserName from "@/components/users/UserName.vue";
import ManagerOrdersStats from "@/views/users/components/ManagerOrdersStats.vue";

export default {
  props: ['editGroup', 'allGroups', 'allUsers', 'savedGroup', 'schedule', 'stats'],
  components: {ManagerOrdersStats, UserName, LoadingButton, Multiselect},
  data() {
    return {
      loading: false,
      record: {
        data: [{group: null, users: {shift_1: [], shift_2: []}, schedule: 0}],
      }
    }
  },
  created() {
    if (this.presentGroup) {
      this.record.data = this.presentGroup.reduce((acc, r) => {
        acc.push({
          ...r,
          group: this.allGroups.find((g) => g.id === r.group),
          users: {...r.users},
          to_delete: false
        });
        return acc;
      }, []);
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        acc[p.id] = p;
        return acc;
      }, {})
    },
  },
  methods: {
    async saveGroup() {
      this.loading = true;
      const {data} = await api.post('/new/users/managers/groups/history', {
        record: this.editGroup
      })
      this.loading = false;
    }
  }
}

</script>
